export default __webpack_public_path__ + "static/media/courseBg2.b5fda8a9.png";